
export const Data =[
    {
        id: 1,
        img:'/img/aliexpress.JPG',
        description:'Aliexpress clone site built with react js and tailwind css',
        gitlink:'https://github.com/oshela/oliexpress',
        livelink:'https://eliexpress.netlify.app'
    },
    {   
        id: 2,
        img:'/img/kilishi.JPG',
        description:'beef jerky and saharan suya client ecommerce platform',
        gitlink:'/',
        livelink:'https://kilishisuya.com/'},

    {   
        id: 3,
        img:'/img/farmers.JPG',
        description:'farmers database management system for jgreens',
        gitlink:'https://github.com/oshela/farmers-hub',
        livelink:'http://farmershub.jgreens.ng/'},
    {
        id: 4,
        img:'/img/weather.JPG',
        description:'react weather application with @WeatherAPI',
        gitlink:'https://github.com/oshela/weather-app',
        livelink:'http://oshla-weather-app.netlify.app/'
    },
    {
        id: 5,
        img:'/img/africaconsult.PNG',
        description:'official website for africa consult',
        gitlink:'https://github.com/oshela/',
        livelink:'https://africaconsult.org/'
    },
    {
        id: 6,
        img:'/img/debateguild.PNG',
        description:'official Website for plateau debate guild',
        gitlink:'https://github.com/oshela/',
        livelink:'https://plateaudebateguild.org/'
    },
    {
        id: 7,
        img:'/img/staff-records.JPG',
        description:'simplicity concept nigeria staff records management system.',
        gitlink:'https://github.com/oshela/office-sign',
        livelink:'https://attendance.simplicity.ng/index.php'
    },
    {
        id: 8,
        img:'/img/react-blog.JPG',
        description:'Functional react blogging application',
        gitlink:'https://github.com/oshela/react-blog',
        livelink:'http://oshla-react-blog.netlify.app/'
    },
    {
        id: 9,
        img:'/img/hospital.JPG',
        description:'client hospital site markup',
        gitlink:'https://github.com/oshela/hospital-site',
        livelink:'https://oshela.github.io/hospital-site/'
    },
    {
        id: 10,
        img:'/img/reciepe.JPG',
        description:'reciepe website built with tailwind css',
        gitlink:'https://github.com/oshela/reciepe',
        livelink:'https://oshela.github.io/reciepe/'
    },
    {
        id: 11,
        img:'/img/youtube.JPG',
        description:'youtube landing page clone',
        gitlink:'https://github.com/oshela/youtube',
        livelink:'https://oshela.github.io/youtube/'
    },
    {
        id: 12,
        img:'/img/natours.JPG',
        description:'the Natours project',
        gitlink:'https://github.com/oshela/natours',
        livelink:'https://oshela.github.io/natours/'
    },
    {
        id: 13,
        img:'/img/ecommerce.JPG',
        description:'agricultural ecommerce,loaning and investment',
        gitlink:'https://github.com/oshela/agritech-ecom-application',
        livelink:'https://pj.simplicity.ng/'
    }
]